module.exports = __webpack_public_path__ + "img/effenaar-experiences-qr-code-apple.13f5869d.png";